module.exports = __webpack_public_path__ + "static/media/portfolio-site.e6920a50.png";